import React from "react";
import './question.css';
import HeaderSurvey from '../../components/headersurvey/headersurvey.component';
import ResultPage from '../result-page';
import { Link } from "react-router-dom";
const Questionaire = () => {
  const [currentStep, setCurrentStep] = React.useState(1);
  const [doseTime, setDoseTime] = React.useState([]);
  const [doseVaccine, setDoseVaccine] = React.useState([]);
  
  const handleSelectDoseTime = (value) => {
    if (doseTime.includes(value)) {
      let time = doseTime.filter(time => time !== value);
      setDoseTime(time);
    } else {
      setDoseTime([...doseTime, value])
    }
  }

  const handleSelectDoseVaccine = (value) => {
    if (doseVaccine.includes(value)) {
      let vaccine = doseVaccine.filter(vaccine => vaccine !== value);
      setDoseVaccine(vaccine);
    } else {
      setDoseVaccine([...doseVaccine, value])
    }
  }

  const onNextStep = (step) => {
    if (step === 2) {
      setCurrentStep(2)
    }
    if (step === 3) {
      setCurrentStep(3)
    }
    if (step === 4) {
      setCurrentStep(4)
    }
    if (step === 5) {
      setCurrentStep(5)
    }

  }
  return (
    <>
      {currentStep === 1 && <><HeaderSurvey currentStep={currentStep} setCurrentStep={setCurrentStep} />
        <section className="pp-section pp-section--quiz pt-0">
          <div className="hp-questions-txt-mod section-inner">
            <p className="section-subh">2 of 5</p>
            <h2 className="quiz-h section-h mb-0">
              <span className="js-result--title-pronoun">I am a...</span>
            </h2>
            <form className="padding_top_content">
              <div className="hp-questions-tree inline-items-mod pt-0">

                <button
                  className="hp-questions-selection js-quiz-question"
                  onClick={() => onNextStep(2)}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/dentist.svg")}></img>
                  <span className="quiz_label_class">Patient</span>
                </button>

                <button onClick={() => onNextStep(2)}


                  className="hp-questions-selection js-quiz-question"
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/hospital.svg")}></img>
                  <span className="quiz_label_class">Caretaker</span>
                </button>
              </div>
            </form>
          </div>
        </section> </>}
      {currentStep === 2 && <><HeaderSurvey currentStep={currentStep} setCurrentStep={setCurrentStep} />
        <section className="pp-section pp-section--quiz pt-0">
          <div className="hp-questions-txt-mod section-inner">
            <p className="section-subh">3 of 5</p>
            <h2 className="quiz-h section-h mb-0">
              <span className="js-result--title-pronoun">I am prescribed about...</span>
            </h2>
            <form className="padding_top_content pl-0 pb-0">
              <div className="hp-questions-tree inline-items-mod pt-0">
                <button onClick={() => onNextStep(3)}
                  className="hp-questions-selection js-quiz-question"
                >
                  <p className="mb-0 font_setting" style={{ color: "#17A4DC", fontSize: "52px" }}>1-3</p>
                  <span className="quiz_label_class">Medications</span>
                </button>
                <button onClick={() => onNextStep(3)}
                  className="hp-questions-selection js-quiz-question"
                >
                  <p className="mb-0 font_setting" style={{ color: "#17A4DC", fontSize: "52px" }}>4-6</p>
                  <span className="quiz_label_class">Medications</span>
                </button>
                <button onClick={() => onNextStep(3)}
                  className="hp-questions-selection js-quiz-question"
                >
                  <p className="mb-0 font_setting" style={{ color: "#17A4DC", fontSize: "52px" }}>7-10</p>
                  <span className="quiz_label_class">Medications</span>
                </button>
                <button onClick={() => onNextStep(3)}
                  className="hp-questions-selection js-quiz-question"
                >
                  <p className="mb-0 font_setting" style={{ color: "#17A4DC", fontSize: "52px" }}>10+</p>
                  <span className="quiz_label_class">Medications</span>
                </button>
              </div>
            </form>
          </div>
        </section></>}
      {currentStep === 3 && <><HeaderSurvey currentStep={currentStep} setCurrentStep={setCurrentStep} />
        <section className="pp-section pp-section--quiz pt-0">
          <div className="hp-questions-txt-mod section-inner">
            <p className="section-subh">4 of 5</p>
            <h2 className="quiz-h section-h mb-0">
              <span className="js-result--title-pronoun">I take my medicines in the...</span>
              <p className="mb-0" style={{ fontSize: "18px", color: "#1B1C1E" }}>Choose all that apply</p>
            </h2>
            <form className="padding_top_content pl-0 pb-0">
              <div className="hp-questions-tree inline-items-mod pt-0">
                <button type="button" onClick={() => { handleSelectDoseTime("morning") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseTime.includes("morning") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/sun.svg")}></img>
                  <span className="quiz_label_class">Morning</span>
                </button>
                <button type="button" onClick={() => { handleSelectDoseTime("after_noon") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseTime.includes("after_noon") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/sun1.svg")}></img>
                  <span className="quiz_label_class">After noon</span>
                </button>
                <button type="button" onClick={() => { handleSelectDoseTime("evening") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseTime.includes("evening") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/night.svg")}></img>
                  <span className="quiz_label_class">Evening</span>
                </button>
              </div>
            </form>
          </div>
          <div className="text-center mt-5">
            {
              doseTime.length ? (
                <Link onClick={() => onNextStep(4)} className="text-decoration-none" style={{ fontSize: "26px" }}>
                  Continue <i style={{ fontSize: "18px" }} className="fa fa-chevron-right ml-3"></i>
                </Link>
              ) : (
                  <a className="text-decoration-none" style={{ fontSize: "26px", opacity: "0.5", cursor: "default" }}>
                    Continue <i style={{ fontSize: "18px" }} className="fa fa-chevron-right ml-3"></i>
                  </a>
                )
            }
          </div>
        </section> </>}
      {currentStep === 4 && <><HeaderSurvey currentStep={currentStep} setCurrentStep={setCurrentStep} />
        <section className="pp-section pp-section--quiz pt-0">
          <div className="hp-questions-txt-mod section-inner">
            <p className="section-subh">5 of 5</p>
            <h2 className="quiz-h section-h mb-0">
              <span className="js-result--title-pronoun">I also need...</span>
              <p className="mb-0" style={{ fontSize: "18px", color: "#1B1C1E" }}>Choose all that apply</p>
            </h2>
            <form className="padding_top_content pl-0 pb-0">
              <div className="hp-questions-tree inline-items-mod pt-0">
                <button type="button" onClick={() => { handleSelectDoseVaccine("inhaler") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseVaccine.includes("inhaler") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/asthma.svg")}></img>
                  <span className="quiz_label_class">Inhaler</span>
                </button>
                <button type="button" onClick={() => { handleSelectDoseVaccine("insulin") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseVaccine.includes("insulin") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/insulin.svg")}></img>
                  <span className="quiz_label_class">Insulin</span>
                </button>
                <button type="button" onClick={() => { handleSelectDoseVaccine("birth_control") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseVaccine.includes("birth_control") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/contraception.svg")}></img>
                  <span className="quiz_label_class">Birth Control</span>
                </button>
                <button type="button" onClick={() => { handleSelectDoseVaccine("vitamins") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseVaccine.includes("vitamins") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/vitamin.svg")}></img>
                  <span className="quiz_label_class">Vitamins</span>
                </button>
                <button type="button" onClick={() => { handleSelectDoseVaccine("others") }}
                  className="hp-questions-selection js-quiz-question"
                  style={{ border: doseVaccine.includes("others") ? "1px solid #0af" : "" }}
                >
                  <img className="hp-questions-icon" src={require("../../assets/images/hospital2.svg")}></img>
                  <span className="quiz_label_class">Others</span>
                </button>
              </div>
            </form>
          </div>
          <div className="text-center mt-5">
            <button onClick={() => onNextStep(5)} type="button" className="btn btn-lg d-block btn_pricing_case mx-auto" style={{ fontSize: "15px" }}>
              See Results <img className="pl-2" src={require("../../assets/images/angel.png")}></img>
            </button>
          </div>
        </section> </>}
      {currentStep === 5 && <> <HeaderSurvey currentStep={currentStep} setCurrentStep={setCurrentStep} />
        <ResultPage doseTime={doseTime} doseVaccine={doseVaccine} />
      </>}
    </>
  )
}
export default Questionaire;